
export const groupCustomizeStepEditors = (editors) => ({

    loading: editors.some((e) => e.loading),

    changed: !!editors.some((e) => e.changed),

    hasRequiredError: editors.some((e) => e?.hasRequiredError),

    getErrorMessages: async () => {
        let ret = [];
        for (const editor of editors) {
            const errorMessages = await editor?.getErrorMessages();
            if (errorMessages?.length) {
                ret.push(...errorMessages);
            }
        }
        return ret;
    },

    save: async (params) => {
        for (const editor of editors) {
            const result = (await editor?.save(params) ?? true);
            if (!result) {
                return result;
            }
        }
        return true;
    },

});

